/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { FaPalette, FaSave } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenModales, setTheme, setThemeColors } from '../../store/global';
import { BtnRound } from '../form/btn.Round';
import { InputSimple } from '../form/input.Simple';
import { ModalGlobal } from '../modal/modal.Global';
import { SettingsSelect } from '../form/settings.Widget';
import { getStorageValue, setStorageValue } from '../../utils/userStorage';

export const ThemeChange = () => {
  const theme = useSelector(state => state.global.theme);
  const dispatch = useDispatch();

  const [savedThemes, setSavedThemes] = useState([]);
  const [currentTheme, setCurrentTheme] = useState('theme-default-dark');

  const saveCurrentTheme = themeId => {
    setStorageValue('currentTheme', themeId);
    setCurrentTheme(themeId);

    getThemes();
  };

  const getThemes = () => {
    const themes = Object.keys(window.localStorage).filter(key =>
      key.startsWith('theme-')
    );
    themes.sort((a, b) => {
      if (a < b) {
        return -1;
      }
      if (a > b) {
        return 1;
      }
      return 0;
    });

    setSavedThemes(themes);
  };

  function rgbToHex(rgb) {
    const [r, g, b] = rgb.split(' ').map(Number);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(
          result[3],
          16
        )}`
      : null;
  }

  useEffect(() => {
    getThemes();
    if (getStorageValue('currentTheme') === null) {
      saveCurrentTheme('theme-default-dark');
    }
  }, []);

  useEffect(() => {
    const nextTheme = getStorageValue('currentTheme');
    if (nextTheme) {
      setCurrentTheme(nextTheme);
    }
  }, [savedThemes]);

  return (
    <>
      <ModalGlobal
        idToOpen={'themeChange'}
        title='Changer de thème'
      >
        <div className='w-full flex items-center justify-center gap-1 flex-wrap'>
          <div className='w-full flex justify-center items-center gap-1'>
            <div>Charger un thème</div>
            <SettingsSelect
              onChange={e => {
                const theme = JSON.parse(
                  window.localStorage.getItem(e.target.value)
                );
                saveCurrentTheme(e.target.value);
                dispatch(setTheme(theme));
              }}
              defaultValue={currentTheme}
              value={currentTheme}
            >
              {savedThemes.map((key, i) => {
                return (
                  <option
                    key={i}
                    value={key}
                  >
                    {key.replace('theme-', '')}
                  </option>
                );
              })}
            </SettingsSelect>
          </div>
          {Object.keys(theme).map((key, i) => {
            return (
              <div
                className='flex flex-col w-1/5'
                key={i}
              >
                {/* <div className={`bg-${key} p-2 rounded`}></div> */}
                <InputSimple
                  className={'mx-0'}
                  placeholder={key}
                  initValue={theme[key]}
                  onBlur={value => dispatch(setThemeColors({ key, value }))}
                />
                <input
                  type='color'
                  className='w-full h-12 bg-transparent'
                  onChange={e => {
                    dispatch(
                      setThemeColors({ key, value: hexToRgb(e.target.value) })
                    );
                  }}
                  value={rgbToHex(theme[key])}
                />
              </div>
            );
          })}

          <div className='w-full flex items-center gap-1'>
            <div>Sauvegarder le thème</div>
            <InputSimple
              className={'mx-0'}
              placeholder={'nom du thème'}
              initValue={''}
              onBlur={value => {
                const themeKey = 'theme-' + value;
                setStorageValue(themeKey, JSON.stringify(theme), {
                  mirrorGlobal: true,
                });
                saveCurrentTheme(themeKey);
              }}
            />
            <BtnRound onClick={() => null}>
              <FaSave />
            </BtnRound>
          </div>
        </div>
      </ModalGlobal>

      <button
        type='button'
        aria-label='Changer de thème'
        title='Changer de thème'
        className='cursor-pointer hover:opacity-50 transition'
        onClick={() =>
          dispatch(setOpenModales({ id: 'themeChange', open: true }))
        }
      >
        <FaPalette />
      </button>
    </>
  );
};
